import { createFileRoute } from "@tanstack/react-router";
import { MessagingScreen } from "../components/settings/messaging-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/integrationer")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <MessagingScreen franchiseId={franchise.id} />;
}
